import React from 'react';
import './App.css';
import 'bulma/css/bulma.min.css';

//font
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons'


// ==============================|| APP ||============================== //
function App() {
    return (
    <div className="App">
      <header className="App-header">
        <p>
          Welcome to OCPF React Applications
        </p>
      </header>
    </div>
  );
}

export default App;
library.add(fas, far);